import { createContext } from "react";

enum viewTypes {
    TaskListWaiting = 1,
    TaskListLocal,
}

const ViewTaskListContext = createContext({
    viewTaskListTypes: viewTypes,
    viewTaskListType: viewTypes.TaskListWaiting,
    setViewTaskListType: (viewType: number) => {}
});

export default ViewTaskListContext;